angular.module('unica_event_field.event_field_services')

.factory('EventFieldCreateService', function ($http, getBaseApiURL) {

	var eventFieldCreateService = {};

	eventFieldCreateService.create = function ( eventFieldData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-field/create',
			data: eventFieldData
		}).then(function(result) {

			if ( result ) {
				return result.data.eventField;
			}
		});
 
	};

	eventFieldCreateService.clone = function ( eventFieldId ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-field/clone/' + eventFieldId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.eventField;
			}

		});

	};

	return eventFieldCreateService;
});